<template>
  <b-container fluid class="p-4">
    <h3 class="mb-4">ویرایش تخفیف</h3>

    <form-offer
        :submit="updateOffer"
        :form="offer"
    />

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import FormOffer from "./Form.vue";
import router from "@/router";

export default {
  name: "Update",
  components: {FormOffer},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      offer: "Offer/getOffer",
    }),
  },
  methods: {
    updateOffer() {
      console.log(this.offer, "update");
      this.$store.dispatch("Offer/updateOffer", this.offer);
    },
  },
  async mounted() {
    const offerId = router.currentRoute.params.id;
    await this.$store.dispatch("Offer/getOffer", offerId);
  },
};
</script>

<style scoped>
</style>